export default __webpack_public_path__ + "static/media/img-0773-sweden-full-face.1fde7954.png";